var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{staticClass:"flexed",attrs:{"sm":"12"}},[_c('h1',[_vm._v("404 / Page Not Found")]),_c('div',{staticClass:"mt-3"},[_c('a',{attrs:{"href":"/"}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'home']}}),_vm._v(" Home")],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }